<template>
    <UTooltip :text="tooltipText" :popper="{ placement: 'top' }">
        <div class="flex items-center space-x-1.5 cursor-pointer hover:opacity-80 transition-opacity" @click.stop="copyToClipboard">
            <UIcon v-if="isValidPhone && countryCode" :name="`i-circle-flags-${countryCode.toLowerCase()}`" dynamic />
            <span>{{ formattedNational }}</span>
        </div>
    </UTooltip>
</template>
<script setup lang="ts">
const props = defineProps<{
    value: string
}>()

const toast = useToast()
const { countryCode, formattedNational, isValidPhone, parse } = usePhone()

const parsedPhone = ref<ReturnType<typeof parse>>()
const countryName = ref<string>()

onMounted(() => setPhone())
watch(
    () => props.value,
    () => setPhone(),
)

function setPhone() {
    if (props.value) {
        parsedPhone.value = parse(props.value.charAt(0) == '+' ? props.value : '+' + props.value)
        updateCountryName()
    }
}

function updateCountryName() {
    if (countryCode.value) {
        const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })
        countryName.value = regionNames.of(countryCode.value)
    }
}

const formattedInternational = computed(() => {
    return parsedPhone.value?.formatInternational() || props.value
})

const tooltipText = computed(() => {
    return formattedInternational.value + (countryName.value ? ` (${countryName.value})` : '')
})

async function copyToClipboard() {
    try {
        const phoneToCopy = formattedInternational.value.replace(/\s+/g, '')
        await navigator.clipboard.writeText(phoneToCopy)
        toast.add({
            title: 'Phone number copied',
            description: phoneToCopy,
            icon: 'i-heroicons-check-circle',
        })
    } catch (error) {
        toast.add({
            title: 'Failed to copy',
            color: 'red',
            icon: 'i-heroicons-x-circle',
        })
    }
}
</script>
